import { Button, CheckboxList, DefaultCard } from '../../components';
import { ButtonTypeEnum, ButtonVariantEnum } from '../../enums';
import { CheckboxListOptionType, EleitoresListType } from '../../types';
import { FaExclamationCircle, FaSearch } from 'react-icons/fa';
import { FunctionComponent, useEffect, useState } from 'react';

import { Form } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EleitoresList: FunctionComponent<EleitoresListType> = ({
  formikProps,
  eleitoresDisplayList,
  idEleicao,
  cardTitle,
  cardSubtitle,
  cardInfo = null,
  cardIcon,
  emptySearchMsg,
  mainActionTitle,
  mainActionButtonVariant = ButtonVariantEnum.PRIMARY,
  headerAction = null,
  handleLimparBusca = null,
  expandCard = false,
  isForRemoval = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [listTotal, setListTotal] = useState(0);
  const [listSelected, setListSelected] = useState(0);

  useEffect(() => {
    setListSelected(eleitoresDisplayList?.filter((e) => formikProps.values[e.id] === true).length);
  }, [formikProps.values]);

  useEffect(() => {
    setListTotal(eleitoresDisplayList?.length);
  }, [eleitoresDisplayList]);

  return (
    <Form>
      <DefaultCard
        cardTitle={cardTitle}
        cardSubtitle={cardSubtitle}
        cardIcon={cardIcon}
        helpLink={
          'https://conhecimento.sti.ufpb.br/books/sistema-de-cadastro-de-eleicoes/page/gerenciar-os-eleitores-do-grupo-de-eleitores'
        }
        headerClassName={'responsive-spacing'}
        mainActionButton={headerAction}
        empty={eleitoresDisplayList!.length < 1}
        emptyMessage={emptySearchMsg}
        emptyIcon={FaSearch}
        singleCardPage={expandCard}
        headerAction={
          <div className={'d-flex justify-content-end align-items-center gap-3 flex-shrink-0'}>
            {listTotal > 0 && (
              <div>
                <span className="fs-4">{listSelected}</span>
                <span className="text-muted text-lowercase">{` ${t('label.selecionados')}/ ${listTotal}`}</span>
              </div>
            )}
          </div>
        }
        footer={
          <div className="d-flex justify-content-center gap-5">
            <Button
              title={t('label.voltar')}
              type={ButtonTypeEnum.BUTTON}
              onClick={(event) => {
                navigate(`/eleicoes/${idEleicao}/grupos-eleitores/alterar`);
              }}
              outline
              disabled={formikProps.isSubmitting || formikProps.isValidating}
            />
            {handleLimparBusca && (
              <Button
                title={t('label.limpar_busca')}
                type={ButtonTypeEnum.BUTTON}
                onClick={handleLimparBusca}
                outline
                disabled={formikProps.isSubmitting || formikProps.isValidating}
              />
            )}
            <Button
              title={mainActionTitle}
              type={ButtonTypeEnum.SUBMIT}
              variant={mainActionButtonVariant}
              disabled={
                formikProps.isSubmitting ||
                formikProps.isValidating ||
                eleitoresDisplayList!.length < 1 ||
                (isForRemoval && listSelected <= 0)
              }
            />
          </div>
        }
      >
        {cardInfo && <div className="alert alert-info mt-2 mb-2" dangerouslySetInnerHTML={{ __html: cardInfo }} />}
        {eleitoresDisplayList!.length < 1 ? (
          <div className="d-flex justify-content-center align-items-center p-4">{emptySearchMsg}</div>
        ) : (
          <CheckboxList
            formikProps={formikProps}
            label={t('label.eleitores')}
            name={'eleitores'}
            tooltipIcon={FaExclamationCircle}
            headers={['Nome', 'Matrícula', 'Unidade']}
            options={eleitoresDisplayList!.map((eleitor): CheckboxListOptionType => {
              return {
                highlight: eleitor.duplicado,
                id: eleitor.id,
                labels: [eleitor.nome, eleitor.matricula, eleitor.origem],
                tooltip: eleitor.grupo_duplicacao
                  ? t('label.eleitor_duplicado_grupo_maior_prioridade', { grupo_duplicacao: eleitor.grupo_duplicacao })
                  : eleitor.grupo_duplicacao,
              };
            })}
            columnSizes={[5, 2, 5]}
            dangerOnSelect={isForRemoval}
            dangerOnDeselect={!isForRemoval}
          />
        )}
      </DefaultCard>
    </Form>
  );
};

export default EleitoresList;
